import {
  createRouter,
  createWebHistory,
  createWebHashHistory,
  RouteRecordRaw,
} from "vue-router";
import { getToken, removeToken } from "@/plugins/cookie";
import axios from "axios";

const is_mobile = navigator.userAgent.match(
  // eslint-disable-next-line no-irregular-whitespace
  /(phone|pod|iPhone|iPod|Android|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|Symbian|Windows Phone)/i
);

// web菜单
export const homeMenu: Array<RouteRecordRaw> = [
  {
    path: "/ranking",
    name: "Ranking",
    redirect: "/ranking/list",
    meta: {
      title: "线索池",
      icon: "",
      menuType: "Home",
    },
    children: [
      {
        path: "/ranking/list",
        name: "RankingList",
        component: () => import("../views/web/ranking/index.vue"),
        meta: {
          title: "线索池",
          icon: "",
          routeParent: "Pond",
        },
      },
    ],
  },
  {
    path: "/pond",
    name: "Pond",
    redirect: "/pond/list",
    meta: {
      title: "线索池",
      icon: "",
      menuType: "Home",
    },
    children: [
      {
        path: "/pond/list",
        name: "PondList",
        component: () => import("../views/web/pond/List.vue"),
        meta: {
          title: "线索池",
          icon: "",
          routeParent: "Pond",
        },
      },
      {
        path: "/pond/directional-cue",
        name: "DirectionalCue",
        component: () => import("../views/web/pond/DirectionalCue.vue"),
        meta: {
          title: "线索池",
          icon: "",
          routeParent: "Pond",
        },
      },
      {
        path: "/pond/qrientiert",
        name: "OrientiertPond",
        component: () => import("../views/web/pond/Orientiert.vue"),
        meta: {
          title: "线索池",
          icon: "",
          routeParent: "Pond",
        },
      },
      {
        path: "/pond/records",
        name: "PondRecords",
        component: () => import("../views/web/pond/Records.vue"),
        meta: {
          title: "分配记录",
          icon: "",
          routeParent: "Pond",
        },
      },
      {
        path: "/delayed/anchor",
        name: "DelayedAnchor",
        component: () => import("../views/web/delayed-anchor/list.vue"),
        meta: {
          title: "延期主播",
          icon: "",
          routeParent: "Pond",
        },
      },
      {
        path: "/delayed/anchor",
        name: "AnchorDetails",
        component: () => import("../views/web/delayed-anchor/details.vue"),
        meta: {
          title: "延期主播",
          icon: "",
          routeParent: "Pond",
        },
      },
      {
        path: "/pond/regression-record",
        name: "RegressionRecord",
        component: () => import("../views/web/pond/RegressionRecord.vue"),
        meta: {
          title: "回归记录",
          icon: "",
          routeParent: "Pond",
        },
      },
    ],
  },
  {
    path: "/academy",
    name: "Academy",
    meta: {
      title: "达人库",
      icon: "",
      menuType: "Home",
    },
    redirect: "/academy/index",
    children: [
      {
        path: "/academy/index",
        name: "academyIndex",
        component: () => import("../views/web/academy/index.vue"),
        meta: {
          title: "听海学苑",
          icon: "",
          routeParent: "Academy",
        },
      },
      {
        path: "/academy/busdetails",
        name: "BusinessDetails",
        component: () => import("../views/web/academy/BusinessDetails.vue"),
        meta: {
          title: "业务了解",
          icon: "",
          routeParent: "Academy",
        },
      },
      {
        path: "/academy/businessEdit",
        name: "BusinessEdit",
        component: () => import("../views/web/academy/BusinessEdit.vue"),
        meta: {
          title: "业务了解",
          icon: "",
          routeParent: "Academy",
        },
      },
      {
        path: "/academy/customerServiceDetail",
        name: "CustomerServiceDetail",
        component: () =>
          import(
            "../views/web/academy/components/businessdetails/AnswersArt.vue"
          ),
        meta: {
          title: "客服详情",
          icon: "",
          routeParent: "Academy",
        },
      },
    ],
  },
  {
    path: "/master",
    name: "Master",
    meta: {
      title: "达人库",
      icon: "",
      menuType: "Home",
    },
    redirect: "/master/clue",
    children: [
      {
        path: "/master/clue",
        name: "masterClue",
        component: () => import("../views/web/master/Clue.vue"),
        meta: {
          title: "达人线索",
          icon: "",
          routeParent: "Master",
        },
      },
      {
        path: "/master/my",
        name: "masterMy",
        component: () => import("../views/web/master/Master.vue"),
        meta: {
          title: "质检通过",
          icon: "",
          routeParent: "Master",
        },
      },
      {
        path: "/master/quitlist",
        name: "masterQuitlist",
        component: () => import("../views/web/master/quitList.vue"),
        meta: {
          title: "BD离职后的达人",
          icon: "",
          routeParent: "Master",
        },
      },
      {
        path: "/master/quitrecord",
        name: "masterQuitrecords",
        component: () => import("../views/web/master/quitRecords.vue"),
        meta: {
          title: "达人分配记录",
          icon: "",
          routeParent: "Master",
        },
      },
      {
        path: "/master/income",
        name: "masterIncome",
        component: () => import("../views/web/master/Income.vue"),
        meta: {
          title: "达人收益",
          icon: "",
          routeParent: "Master",
        },
      },
      {
        path: "/master/platform-master",
        name: "PlatformMasterList",
        component: () => import("../views/web/master/components/List.vue"),
        meta: {
          title: "达人收益",
          icon: "",
          routeParent: "Master",
        },
      },
      {
        path: "/master/region-list",
        name: "RegionList",
        component: () => import("../views/web/master/clueRegionList.vue"),
        meta: {
          title: "区域统计",
          icon: "",
          routeParent: "Master",
        },
      },
      {
        path: "/master/myClue",
        name: "MyClue",
        component: () => import("../views/web/master/myClue.vue"),
        meta: {
          title: "我的线索",
          icon: "",
          routeParent: "Master",
        },
      },
      {
        path: "/clue-detail",
        name: "ClueDetail",
        component: () => import("../views/web/author-detail/ClueDetail.vue"),
        meta: {
          title: "达人详情",
          icon: "",
          menuType: "Home",
        },
      },
      {
        path: "/master/history-list",
        name: "HistoryList",
        component: () => import("../views/web/master/historyClue.vue"),
        meta: {
          title: "历史释放线索",
          icon: "",
          routeParent: "Master",
        },
      },
      {
        path: "/master/history-regionlist",
        name: "HistoryRegionList",
        component: () => import("../views/web/master/historyRegionList.vue"),
        meta: {
          title: "历史释放线索",
          icon: "",
          routeParent: "Master",
        },
      },
    ],
  },
  {
    path: "/quality",
    name: "Quality",
    meta: {
      title: "质检管理",
      icon: "",
      menuType: "Home",
    },
    redirect: "/qualityclue/list",
    children: [
      {
        path: "/qualityclue/list",
        name: "qualityList",
        component: () => import("../views/web/quality-clue/list.vue"),
        meta: {
          title: "优质线索列表",
          icon: "",
          routeParent: "Utilities",
        },
      },
      {
        path: "/qualityclue/upload",
        name: "qualityUpload",
        component: () => import("../views/web/quality-clue/Upload.vue"),
        meta: {
          title: "上传优质线索",
          icon: "",
          routeParent: "Utilities",
        },
      },
      {
        path: "/qualityclue/regionlist",
        name: "qualityRegionlist",
        component: () =>
          import("../views/web/quality-clue/UtilitiesRegionList.vue"),
        meta: {
          title: "区域统计",
          icon: "",
          routeParent: "Utilities",
        },
      },
    ],
  },
  {
    path: "/utilities",
    name: "Utilities",
    meta: {
      title: "质检管理",
      icon: "",
      menuType: "Home",
    },
    redirect: "/master/utilities",
    children: [
      {
        path: "/master/utilities",
        name: "masterUtilities",
        component: () => import("../views/web/quality/Utilities.vue"),
        meta: {
          title: "质检管理",
          icon: "",
          routeParent: "Utilities",
        },
      },
      {
        path: "/master/upload",
        name: "masterUpload",
        component: () => import("../views/web/quality/Upload.vue"),
        meta: {
          title: "上传质检",
          icon: "",
          routeParent: "Utilities",
        },
      },
      {
        path: "/master/talent-rating",
        name: "talentRating",
        component: () => import("../views/web/bring-court/talentRating.vue"),
        meta: {
          title: "达人评级",
          icon: "",
          routeParent: "Utilities",
        },
      },
      {
        path: "/master/tag",
        name: "masterTagging",
        component: () => import("../views/web/quality/Tagging.vue"),
        meta: {
          title: "质检打标签",
          icon: "",
          routeParent: "Utilities",
        },
      },
      {
        path: "/master/count",
        name: "masterCount",
        component: () => import("../views/web/quality/UtilitiesCount.vue"),
        meta: {
          title: "质检统计", // 未使用
          icon: "",
          routeParent: "Utilities",
        },
      },
      {
        path: "/master/regionlist",
        name: "UtilitiesRegionList",
        component: () => import("../views/web/quality/UtilitiesRegionList.vue"),
        meta: {
          title: "质检区域统计",
          icon: "",
          routeParent: "Utilities",
        },
      },
      {
        path: "/master/clueslist",
        name: "UtilitiesCluesList",
        component: () => import("../views/web/quality/cluesList.vue"),
        meta: {
          title: "修改快手号",
          icon: "",
          routeParent: "Utilities",
        },
      },
      {
        path: "/master/agency-operation",
        name: "AgencyOperation",
        component: () => import("../views/web/quality/AgencyOperation.vue"),
        meta: {
          title: "代运营账号",
          icon: "",
          routeParent: "Utilities",
        },
      },
      {
        path: "/master/label-rules",
        name: "LabelRules",
        component: () => import("../views/web/quality/LabelRules.vue"),
        meta: {
          title: "标签规则",
          icon: "",
          routeParent: "Utilities",
        },
      },
      {
        path: "/master/new-data",
        name: "NewDataList",
        component: () => import("../views/web/quality/NewDataList.vue"),
        meta: {
          title: "听海新增数据",
          icon: "",
          routeParent: "Utilities",
        },
      },
    ],
  },
  {
    path: "/statistics",
    name: "Statistics",
    redirect: "/statistics/list",
    meta: {
      title: "统计",
      icon: "",
      menuType: "Home",
    },
    children: [
      {
        path: "/statistics/datalist",
        name: "statisticsDataList",
        component: () => import("../views/web/statistics/dataList.vue"),
        meta: {
          title: "数据统计",
          icon: "",
          routeParent: "Statistics",
        },
      },
      {
        path: "/statistics/regionlist",
        name: "statisticsRegionList",
        component: () => import("../views/web/statistics/regionList.vue"),
        meta: {
          title: "区域统计",
          icon: "",
          routeParent: "Statistics",
        },
      },
      {
        path: "/data-board/index",
        name: "dataBoard",
        component: () => import("../views/web/data-board/index.vue"),
        meta: {
          title: "数据可视化",
          icon: "",
          routeParent: "Statistics",
        },
      },
      {
        path: "/statistics/approved",
        name: "statisticsApproved",
        component: () => import("../views/web/statistics/Approved.vue"),
        meta: {
          title: "审核通过数据",
          icon: "",
          routeParent: "Statistics",
        },
      },
      {
        path: "/statistics/not-approved",
        name: "statisticsNotApproved",
        component: () => import("../views/web/statistics/NotApproved.vue"),
        meta: {
          title: "已提交数据",
          icon: "",
          routeParent: "Statistics",
        },
      },
    ],
  },
  {
    path: "/court",
    name: "Court",
    redirect: "/court/bring-court",
    meta: {
      title: "提审管理",
      icon: "",
      menuType: "Home",
    },
    children: [
      {
        path: "/court/list",
        name: "BringCourt",
        component: () => import("../views/web/bring-court/List.vue"),
        meta: {
          title: "我的提审",
          icon: "",
          routeParent: "Court",
        },
      },
      {
        path: "/court/upload",
        name: "UploadCourt",
        component: () => import("../views/web/bring-court/Upload.vue"),
        meta: {
          title: "上传提审",
          icon: "",
          routeParent: "Court",
        },
      },
      {
        path: "/court/utilities",
        name: "UtilitiesCourt",
        component: () => import("../views/web/bring-court/Utilities.vue"),
        meta: {
          title: "提审审核",
          icon: "",
          routeParent: "Court",
        },
      },
      {
        path: "/court/regionlist",
        name: "CourtRegionlist",
        component: () =>
          import("../views/web/bring-court/UtilitiesRegionList.vue"),
        meta: {
          title: "提审统计",
          icon: "",
          routeParent: "Court",
        },
      },
      {
        path: "/court/income-regionlist",
        name: "IncomeRegionList",
        component: () =>
          import("../views/web/bring-court/IncomeRegionList.vue"),
        meta: {
          title: "提审收益",
          icon: "",
          routeParent: "Court",
        },
      },
      {
        path: "/court/depart-list",
        name: "CourtDepartList",
        component: () => import("../views/web/bring-court/departList.vue"),
        meta: {
          title: "离职人员数据",
          icon: "",
          routeParent: "Court",
        },
      },
      {
        path: "/court/wechat-statistics",
        name: "WechatStatistics",
        component: () =>
          import("../views/web/bring-court/WechatStatistics.vue"),
        meta: {
          title: "企微认证统计",
          icon: "",
          routeParent: "Court",
        },
      },

      {
        path: "/court/court-tblist",
        name: "CourtTbList",
        component: () => import("../views/web/bring-court/TbList.vue"),
        meta: {
          title: "商务提审列表",
          icon: "",
          routeParent: "Court",
        },
      },
      {
        path: "/court/weChat-list",
        name: "WeChatList",
        component: () => import("../views/web/bring-court/weChatBDList.vue"),
        meta: {
          title: "企微认证列表",
          icon: "",
          routeParent: "Court",
        },
      },
      {
        path: "/court/review-income",
        name: "ReviewIncome",
        component: () => import("../views/web/bring-court/ReviewIncome.vue"),
        meta: {
          title: "合作达人",
          icon: "",
          routeParent: "Court",
        },
      },
      {
        path: "/bring-court/revenue",
        name: "revenueList",
        component: () => import("../views/web/bring-court/revenue.vue"),
        meta: {
          title: "提审收益列表",
          icon: "",
          routeParent: "Court",
        },
      },
      {
        path: "/bring-court/income",
        name: "incomeList",
        component: () => import("../views/web/bring-court/incomeList.vue"),
        meta: {
          title: "昨日收益直播场次",
          icon: "",
          routeParent: "Court",
        },
      },
      {
        path: "/court/allocation-records",
        name: "AllocationRecords",
        component: () =>
          import("../views/web/bring-court/AllocationRecords.vue"),
        meta: {
          title: "提审分配记录",
          icon: "",
          routeParent: "Court",
        },
      },
    ],
  },
  {
    path: "/study",
    name: "Study",
    redirect: "/learning-garden",
    meta: {
      title: "学习园地",
      icon: "",
      menuType: "Home",
    },
    children: [
      {
        path: "/task-list",
        name: "TaskList",
        component: () => import("../views/web/task-manager/TaskList.vue"),
        meta: {
          title: "我的任务",
          icon: "",
          menuType: "Home",
        },
      },
      {
        path: "/learning-garden",
        name: "LearningGarden",
        component: () =>
          import("../views/web/study-manager/LearningGarden.vue"),
        meta: {
          title: "学习园地",
          icon: "",
          routeParent: "Study",
        },
      },
      {
        path: "/learn-list",
        name: "LearnList",
        component: () => import("../views/web/study-manager/LearnList.vue"),
        meta: {
          title: "编辑学习",
          icon: "",
          routeParent: "Study",
        },
      },
      {
        path: "/article-view",
        name: "ArticleView",
        component: () => import("../views/web/study-manager/ArticleView.vue"),
        meta: {
          title: "文章详情",
          icon: "",
          routeParent: "Study",
        },
      },
      {
        path: "/learn-add",
        name: "addLearn",
        component: () =>
          import("../views/web/study-manager/setprocess/addLearn.vue"),
        meta: {
          title: "创建学习",
          icon: "",
          routeParent: "Study",
        },
      },
    ],
  },
  {
    path: "/staff",
    name: "Staff",
    redirect: "/staff/manage",
    meta: {
      title: "设置",
      icon: "",
      menuType: "Home",
    },
    children: [
      {
        path: "/staff/manage",
        name: "StaffManage",
        component: () => import("../views/web/staff/StaffManage.vue"),
        meta: {
          title: "员工管理",
          icon: "",
          routeParent: "Staff",
        },
      },
      {
        path: "/staff/Applicant",
        name: "Applicant",
        component: () => import("../views/web/staff/Applicant.vue"),
        meta: {
          title: "人才数据库",
          icon: "",
          routeParent: "Staff",
        },
      },
      {
        path: "/staff/codeConfiguration",
        name: "codeConfiguration",
        component: () => import("../views/web/staff/codeConfiguration.vue"),
        meta: {
          title: "招聘二维码",
          icon: "",
          routeParent: "Staff",
        },
      },
      {
        path: "/staff/ApplicantDetail",
        name: "ApplicantDetail",
        component: () => import("../views/web/staff/ApplicantDetail.vue"),
        meta: {
          title: "应聘人才库",
          icon: "",
          routeParent: "Staff",
        },
      },
      {
        path: "/staff/ApplicantUpload",
        name: "ApplicantUpload",
        component: () => import("../views/web/staff/uploadFiles.vue"),
        meta: {
          title: "上传简历",
          icon: "",
          routeParent: "Staff",
        },
      },
      {
        path: "/staff/employmentAllocation",
        name: "EmploymentAllocation",
        component: () => import("../views/web/staff/employmentAllocation.vue"),
        meta: {
          title: "应聘登记配置",
          icon: "",
          routeParent: "Staff",
        },
      },
      {
        path: "/staff/add",
        name: "AddSAtaff",
        component: () => import("../views/web/staff/AddSAtaff.vue"),
        meta: {
          title: "添加员工",
          icon: "",
          routeParent: "Staff",
        },
      },
      {
        path: "/staff/AssessmentSettings",
        name: "AssessmentSettings",
        component: () => import("../views/web/staff/AssessmentSettings.vue"),
        meta: {
          title: "测评问卷设置",
          icon: "",
          routeParent: "Staff",
        },
      },
      {
        path: "/staff/AssessmentPaperEdit",
        name: "AssessmentPaperEdit",
        component: () => import("../views/web/staff/AssessmentPaperEdit.vue"),
        meta: {
          title: "测评问卷编辑",
          icon: "",
          routeParent: "Staff",
        },
      },
      {
        path: "/staff/AssessmentResults",
        name: "AssessmentResults",
        component: () => import("../views/web/staff/AssessmentResults.vue"),
        meta: {
          title: "测评结果",
          icon: "",
          routeParent: "Staff",
        },
      },
      {
        path: "/staff/AssessmentResultDetail",
        name: "AssessmentResultDetail",
        component: () => import("../views/web/staff/AssessmentResultDetail.vue"),
        meta: {
          title: "答卷详情",
          icon: "",
          routeParent: "Staff",
        },
      },
    ],
  },
  {
    path: "/platform",
    name: "PlatformLabel",
    redirect: "/platform/claimed-list",
    meta: {
      title: "平台标签",
      icon: "",
      menuType: "Home",
    },
    children: [
      {
        path: "/platform/claimed-list",
        name: "ClaimedList",
        component: () => import("../views/web/platform-label/ClaimedList.vue"),
        meta: {
          title: "领取列表",
          icon: "",
          routeParent: "PlatformLabel",
        },
      },
      {
        path: "/platform/list",
        name: "LeadsReadList",
        component: () =>
          import("../views/web/platform-label/LeadsReadList.vue"),
        meta: {
          title: "平台负责人",
          icon: "",
          routeParent: "PlatformLabel",
        },
      },
      {
        path: "/platform/through",
        name: "ThroughData",
        component: () => import("../views/web/platform-label/ThroughData.vue"),
        meta: {
          title: "质检通过",
          icon: "",
          routeParent: "PlatformLabel",
        },
      },
    ],
  },
  {
    path: "/about",
    name: "AboutView",
    component: () => import("../views/web/other/AboutView.vue"),
    meta: {
      title: "关于我们",
      icon: "",
      menuType: "Home",
    },
  },
  {
    path: "/notice",
    name: "Notice",
    component: () => import("../views/web/other/Notice.vue"),
    meta: {
      title: "平台公告",
      icon: "",
      menuType: "Home",
    },
  },
  {
    path: "/view",
    name: "View",
    component: () => import("../views/web/other/View.vue"),
    meta: {
      title: "公告详情",
      icon: "",
      menuType: "Home",
    },
  },
  {
    path: "/user",
    name: "User",
    component: () => import("../views/web/other/User.vue"),
    meta: {
      title: "修改资料",
      icon: "",
      menuType: "Home",
    },
  },
  {
    path: "/author-detail",
    name: "AuthorDetail",
    component: () => import("../views/web/author-detail/AuthorDetail.vue"),
    meta: {
      title: "达人详情",
      icon: "",
      menuType: "Home",
    },
  },
];

// h5菜单
export const h5Menu: Array<RouteRecordRaw> = [
  {
    path: "/h5-learning",
    name: "learning",
    component: () => import("../views/h5/learning/learning_section.vue"),
    meta: {
      title: "学习",
      icon: "",
      menuType: "h-Home",
    },
  },
  {
    path: "/h5-ranking/list",
    name: "h5Ranking",
    component: () => import("../views/h5/ranking/index.vue"),
    meta: {
      title: "排行榜",
      icon: "",
      menuType: "h-Home",
    },
  },
  {
    path: "/h5-advice",
    name: "advice",
    component: () => import("../views/h5/seek_advice/advice.vue"),
    meta: {
      title: "咨询",
      icon: "",
      menuType: "h-Home",
    },
  },
  {
    path: "/h5-my",
    name: "my",
    component: () => import("../views/h5/my.vue"),
    meta: {
      title: "我的",
      icon: "",
      menuType: "h-Home",
    },
  },
  {
    path: "/h5-task/list",
    name: "task",
    component: () => import("../views/h5/task/task_list.vue"),
    meta: {
      title: "任务",
      icon: "",
      menuType: "h-Home",
    },
  },
  {
    path: "/h5-clues",
    name: "clues",
    component: () => import("../views/h5/inspection/clues.vue"),
    meta: {
      title: "听海云线索",
      icon: "",
      menuType: "h-Home",
    },
  },
  {
    path: "/h5-check_masters",
    name: "check_masters",
    component: () => import("../views/h5/arraign/check_masters.vue"),
    meta: {
      title: "我的提审",
      icon: "",
      menuType: "h-Home",
    },
  },
  {
    path: "/h5-check_detail",
    name: "check_detail",
    component: () => import("../views/h5/arraign/check_detail.vue"),
    meta: {
      title: "达人详情",
      icon: "",
      menuType: "h-check_detail",
    },
  },
  {
    path: "/h5-cooperate",
    name: "cooperate_master",
    component: () => import("../views/h5/inspection/cooperate_master.vue"),
    meta: {
      title: "听海云线索",
      icon: "",
      menuType: "h-Home",
    },
  },
  {
    path: "/h5-arraignment",
    name: "arraignment",
    component: () => import("../views/h5/arraign/arraignment.vue"),
    meta: {
      title: "达人提审",
      icon: "",
      menuType: "h-Home",
    },
  },
  {
    path: "/h5-talentClue",
    name: "talentClue",
    component: () => import("../views/h5/inspection/talentClue.vue"),
    meta: {
      title: "达人线索",
      icon: "",
      menuType: "h-Home",
    },
  },
  {
    path: "/h5-income",
    name: "income",
    component: () => import("../views/h5/arraign/arraign_income.vue"),
    meta: {
      title: "达人提审",
      icon: "",
      menuType: "h-Home",
    },
  },
  {
    path: "/h5-upload",
    name: "upload",
    component: () => import("../views/h5/upload.vue"),
    meta: {
      title: "上传质检",
      icon: "",
      menuType: "h-Home",
    },
  },
  {
    path: "/h5-uploadLedger",
    name: "uploadLedger",
    component: () => import("../views/h5/uploadLedger.vue"),
    meta: {
      title: "上传台账",
      icon: "",
      menuType: "h-Home",
    },
  },
  {
    path: "/h5-masters",
    name: "masters",
    component: () => import("../views/h5/inspection/masters.vue"),
    meta: {
      title: "质检通过",
      icon: "",
      menuType: "h-Home",
    },
  },
  {
    path: "/h5-ledgers",
    name: "ledgers",
    component: () => import("../views/h5/inspection/ledgers.vue"),
    meta: {
      title: "台账通过",
      icon: "",
      menuType: "h-Home",
    },
  },
  {
    path: "/h5-categorical",
    name: "categorical",
    component: () => import("../views/h5/categorical.vue"),
    meta: {
      title: "分类话术",
      icon: "",
      menuType: "h-Home",
    },
  },
  {
    path: "/h5-user",
    name: "userinfo",
    component: () => import("../views/h5/userinfo.vue"),
    meta: {
      title: "听海云",
      icon: "",
      menuType: "h-Info",
    },
  },
  {
    path: "/h5-detail",
    name: "detail",
    component: () => import("../views/h5/inspection/detail.vue"),
    meta: {
      title: "听海云",
      icon: "",
      menuType: "h-Info",
    },
  },
  {
    path: "/h5-detailLedgers",
    name: "detailLedgers",
    component: () => import("../views/h5/inspection/detailLedgers.vue"),
    meta: {
      title: "听海云",
      icon: "",
      menuType: "h-Info",
    },
  },
  {
    path: "/h5-notice",
    name: "notice",
    component: () => import("../views/h5/notice.vue"),
    meta: {
      title: "听海云",
      icon: "",
      menuType: "h-Info",
    },
  },
  {
    path: "/h5-view",
    name: "view",
    component: () => import("../views/h5/view.vue"),
    meta: {
      title: "听海云",
      icon: "",
      menuType: "h-Info",
    },
  },
  {
    path: "/h5-advice/detail",
    name: "advice_detail",
    component: () => import("../views/h5/seek_advice/advice_detail.vue"),
    meta: {
      title: "听海云",
      icon: "",
      menuType: "h-Adcice",
    },
  },
  {
    path: "/h5-advice/view",
    name: "advice_view",
    component: () => import("../views/h5/seek_advice/advice_view.vue"),
    meta: {
      title: "听海云",
      icon: "",
      menuType: "h-Adcice",
    },
  },
  {
    path: "/h5-directional",
    name: "directional",
    component: () => import("../views/h5/inspection/directional.vue"),
    meta: {
      title: "听海云",
      icon: "",
      menuType: "h-Info",
    },
  },
  {
    path: "/h5-directional-detail",
    name: "directionalDetail",
    component: () => import("../views/h5/inspection/directional_detail.vue"),
    meta: {
      title: "听海云",
      icon: "",
      menuType: "h-Info",
    },
  },
  {
    path: "/h5-learning/article",
    name: "H5LearningArticle",
    component: () => import("../views/h5/learning/learning_article.vue"),
    meta: {
      title: "学习文章",
      icon: "",
      menuType: "h-Info",
    },
  },
  {
    path: "/h5-task/detail",
    name: "h5TaskDetail",
    component: () => import("../views/h5/task/task_detail.vue"),
    meta: {
      title: "任务详情",
      icon: "",
      menuType: "h-Info",
    },
  },
  {
    path: "/h5-task/edit",
    name: "h5TaskEdit",
    component: () => import("../views/h5/task/task_edit.vue"),
    meta: {
      title: "编辑任务",
      icon: "",
      menuType: "h-Info",
    },
  },
  {
    path: "/h5-work/login",
    name: "h5WorkLogin",
    component: () => import("../views/h5/work/worklogin.vue"),
    meta: {
      title: "企业数据查看",
      icon: "",
      menuType: "h-Info",
    },
  },
  {
    path: "/h5-work/list",
    name: "h5WorkList",
    component: () => import("../views/h5/work/worklist.vue"),
    meta: {
      title: "企业数据查看",
      icon: "",
      menuType: "h-Info",
    },
  },
];

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "Home",
    component: () => import("../views/HomeView.vue"),
    meta: {
      title: "首页",
      icon: "",
    },
    redirect: "/home/info",
    children: [
      {
        path: "/home/info",
        name: "HomeInfo",
        component: () => import("@/views/web/home/HomeInfo.vue"),
        meta: {
          title: "首页",
          icon: "",
          menuType: "Home",
        },
      },
      ...homeMenu,
    ],
  },
  {
    path: "/home",
    name: "h-Home",
    component: () => import("../views/HomeH5View.vue"),
    meta: {
      title: "首页",
      icon: "",
    },
    redirect: "/h5-home",
    children: [
      {
        path: "/h5-home",
        name: "home",
        component: () => import("../views/h5/home.vue"),
        meta: {
          title: "首页",
          icon: "",
          menuType: "h-Home",
        },
      },
      ...h5Menu,
    ],
  },
  {
    path: "/login",
    name: "Login",
    component: is_mobile
      ? () => import("../views/h5/login.vue")
      : () => import("../views/web/other/Login.vue"),
    meta: {
      title: "登录",
      icon: "",
    },
  },

  {
    path: "/404",
    name: "404",
    component: () => import("../views/404.vue"),
    meta: {
      title: "404",
      icon: "",
    },
  },
  {
    path: "/h5-application-registration",
    name: "h5ApplicationRegistration",
    component: () =>
      import("../views/h5/applicationRegistration/applicationRegistration.vue"),
    meta: {
      title: "听海文化应聘登记",
      icon: "",
    },
  },
  {
    path: "/h5-application-registration-detail",
    name: "h5ApplicationRegistrationDetail",
    component: () =>
      import(
        "../views/h5/applicationRegistration/applicationRegistrationDetail.vue"
      ),
    meta: {
      title: "听海文化应聘登记",
      icon: "",
    },
  },
  {
    path: "/h5-recruitment-welcome",
    name: "h5RecruitmentWelcome",
    component: () =>
      import("../views/h5/applicationRegistration/recruitmentWelcome.vue"),
    meta: {
      title: "听海文化应聘登记",
      icon: "",
    },
  },
  {
    path: "/h5-application-registration-finish",
    name: "h5ApplicationRegistrationFinish",
    component: () =>
      import(
        "../views/h5/applicationRegistration/applicationRegistrationFinish.vue"
      ),
    meta: {
      title: "听海文化应聘登记",
      icon: "",
    },
  },

  {
    path: "/assessment-exam",
    name: "AssessmentExam",
    component: () => import("../views/h5/assessmentExam/assessmentExam.vue"),
    meta: {
      title: "岗位认知测评",
      icon: "",
    },
  },
  {
    path: "/assessment-finish",
    name: "AssessmentFinish",
    component: () => import("../views/h5/assessmentExam/assessmentFinish.vue"),
    meta: {
      title: "测评提交结果",
      icon: "",
    },
  },

  {
    path: "/:catchAll(.*)",
    redirect: "/404",
  },
];

const router = createRouter({
  history: createWebHashHistory(process.env.BASE_URL),
  routes,
});

const BaseTitle = "听海云";

router.beforeEach(async (to, from, next) => {
  const externalRouting = [
    "h5ApplicationRegistration",
    "h5ApplicationRegistrationDetail",
    "h5RecruitmentWelcome",
    "h5ApplicationRegistrationFinish",
    // 测评系统 H5：考生扫码免登录访问（追加，勿删）
    "AssessmentExam",
    "AssessmentFinish",
  ];
  // 解决缓存导致菜单点击无效
  if (from.path !== "/") {
    checkAppNewVersion();
  }
  document.title = (to.meta.title ? to.meta.title : BaseTitle) as string;
  if (externalRouting.includes(to.name as string)) {
    next();
    return;
  }
  if (is_mobile) {
    to.meta.isBack = false;
    //判断是否为子页面回退
    if (from.name == "detail") {
      to.meta.isBack = true;
    }
  }

  const BaseWhiteList = ["Login"];

  let list: any = [];
  router.options.routes[1].children?.forEach((item) => {
    list.push(item.name);
  });
  switch (true) {
    case !getToken() && !BaseWhiteList.includes(to.name as string):
      next({ name: "Login" });
      break;

    case getToken() && BaseWhiteList.includes(to.name as string):
      is_mobile ? next({ name: "home" }) : next({ name: "Home" });
      break;

    case is_mobile && !list.includes(to.name as string):
      removeToken();
      next();
      break;
    default:
      next();
      break;
  }
});

// 检查服务端是否已经更新，如果更新刷新页面
async function checkAppNewVersion() {
  const url = `/dist/version.json?t=${Date.now()}`;
  let res = null;
  try {
    res = await axios.get(url);
  } catch (err) {
    console.error("checkAppNewVersion error: ", err);
  }
  if (!res) return;
  const version = res.data.version;
  const localVersion = localStorage.getItem("APP_VERSION");
  if (localVersion && localVersion !== version) {
    localStorage.setItem("APP_VERSION", version);
    window.location.reload();
  }
  localStorage.setItem("APP_VERSION", version);
}
export default router;
